export default __webpack_public_path__ + "static/media/photo9.610aff26.jpg";